import DogMemberRelation from './DogMemberRelation';

export default class Dog {
    static fromData(data) {
        if (!data) {
            return;
        }

        const dog = new Dog();
        dog.id = data.id;
        dog.hasAvatar = data.hasAvatar;
        dog.avatarFileName = data.avatarFileName;
        dog.name = data.name;
        dog.gender = data.gender;
        dog.dateOfBirth = data.dateOfBirth;
        dog.dateOfDeath = data.dateOfDeath;
        dog.breed = data.breed;
        dog.breedSpecialization = data.breedSpecialization;
        dog.breedingBookNumber = data.breedingBookNumber;
        dog.chipNumber = data.chipNumber;
        if (data.relations) {
            dog.relations = data.relations.data.map((data) => DogMemberRelation.fromData(data));
        }
        if (data.memberClubFees) {
            dog.memberClubFees = data.memberClubFees.map((data) => ({ id: data.id, name: data.name, member: data.member }));
        }
        if (data.passedExams) {
            dog.passedExams = data.passedExams.map((data) => ({ id: data.id, title: data.title, examDate: data.examDate, status: data.status }));
        }
        if (data.usabilityPass) {
            dog.usabilityPass = { exhibited: data.usabilityPass.exhibited, exhibitionDate: data.usabilityPass.exhibitionDate, url: data.usabilityPass.url };
        }

        Object.seal(dog);
        return dog;
    }

    serialize() {
        const dog = Object.assign({}, this);
        dog.breed = dog.breed ? dog.breed.key : null;
        dog.breedSpecialization = dog.breedSpecialization ? dog.breedSpecialization.key : null;
        return dog;
    }
}
